import { GoogleAnalytics } from '../google-analytics';
import Store from '../../../_utils/tools/store';
import { CartItemsAnalyticsEvents } from '../../../_cart/cart-items-change-events';

export class GoogleAnalyticsBeginCheckoutEvent extends GoogleAnalytics {
  items() {
    return (this.dataLayer.items || []).map(item =>
      this.mapToItemEventKeys(item)
    );
  }

  beginCheckoutParams() {
    const defaultParams = {
      currency: this.currency(),
      transaction_id: this.transactionId(),
    };

    if (this.modifiedCart()) {
      return {
        ...defaultParams,
        ...this.updatedCartContents(),
      };
    }

    return {
      ...defaultParams,
      value: this.orderValue(),
      items: this.items(),
    };
  }

  sendEvent() {
    if (this.analyticsEnabled() && this.dataLayerEnabled()) {
      if (Store.isWalmart()) {
        // Capture cart as a purchase event for analytics before redirect to Walmart
        super.sendEvent('purchase', this.beginCheckoutParams());
        return;
      }

      super.sendEvent('begin_checkout', this.beginCheckoutParams());
    }
  }

  updatedCartContents() {
    const cartUpdates = window.dataLayer
      .filter(layer =>
        layer.event === CartItemsAnalyticsEvents.UPDATED && layer.cart_value
      )
      .pop();

    return {
      items: (cartUpdates.items || []).map(item => this.mapToItemEventKeys(item)),
      value: Number(this.stripCurrencySymbol(cartUpdates.cart_value)),
    };
  }

  modifiedCart() {
    return window.dataLayer.some(
      layer =>
        layer.event === CartItemsAnalyticsEvents.UPDATED && layer.cart_value
    );
  }

  mapToItemEventKeys(item) {
    const {
      catalog_item_id,
      id,
      category,
      product_title,
      quantity,
      price,
      total_price,
      delivery_option,
    } = item;

    return {
      item_id: id,
      item_name: product_title,
      affiliation: window.location.host,
      catalog_item_id: catalog_item_id,
      item_category: category?.title || category,
      price: Number(this.stripCurrencySymbol(price)),
      quantity: Number(quantity),
      total_price: Number(this.stripCurrencySymbol(total_price)),
      delivery_option: delivery_option,
    };
  }
}
